var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.5,
    height: 24.375,
    viewBox: "0 0 32.5 24.375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M30.333,0a2.069,2.069,0,0,1,1.354.542A1.93,1.93,0,0,1,32.5,2.167V22.479a2.069,2.069,0,0,1-.542,1.354,2.9,2.9,0,0,1-1.625.542H2.167a2.9,2.9,0,0,1-1.625-.542A2.9,2.9,0,0,1,0,22.208V2.167A2.069,2.069,0,0,1,.542.813,1.93,1.93,0,0,1,2.167,0ZM9.208,4.875a3.075,3.075,0,0,0-2.167-.812,3.075,3.075,0,0,0-2.167.813,3.075,3.075,0,0,0-.812,2.167,3.075,3.075,0,0,0,.813,2.167,3.075,3.075,0,0,0,2.167.812,3.075,3.075,0,0,0,2.167-.812,3.075,3.075,0,0,0,.812-2.167A3.075,3.075,0,0,0,9.208,4.875ZM28.438,20.313,20.313,8.125,13,17.6,8.125,14.083,4.063,20.313Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/Photo.fcf5daf2ee7984c2b989752082484d0a.svg";
export { ForwardRef as ReactComponent };